import { ErrorHandler, Injectable, Injector } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any) {
    const logger = this.injector.get('GenericLogger');
    //FIXME logger should handle this better on the browser
    console.error(error);
    if (!error?.stack) {
      const stack = new Error().stack;
      logger.error({ msg: 'Global Error Handler detected object', error, stack });
    } else {
      logger.error({ msg: 'Global Error Handler detected error', error });
    }
  }
}
